// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ReMapUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ReMapUtils.bs.js";

function getSchema(param) {
  return Curry._3(ReMapUtils$Catalyst.StringMap.add, "admin_comment", /* String */0, Curry._3(ReMapUtils$Catalyst.StringMap.add, "partner_comment", /* String */0, Curry._3(ReMapUtils$Catalyst.StringMap.add, "amount", /* Number */1, Curry._3(ReMapUtils$Catalyst.StringMap.add, "vehicle_number", /* String */0, Curry._3(ReMapUtils$Catalyst.StringMap.add, "driver_msisdn", /* Msisdn */2, ReMapUtils$Catalyst.StringMap.empty)))));
}

export {
  getSchema ,
  
}
/* ReMapUtils-Catalyst Not a pure module */
